import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-zoom',
	templateUrl: './zoom.component.html',
	styleUrls: ['./zoom.component.scss']
})
export class ZoomComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('zoomForm', { static: true }) zoomForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	zoomFormSubscription: Subscription;
	isAdmin;

	constructor(private comService: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.zoomFormSubscription = this.zoomForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave((this.zoomForm.dirty && this.zoomForm.invalid) || this.nameField.editComponentName)
				),
				filter((form) => this.zoomForm.dirty && this.zoomForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.zoomFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}
}
